import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import React, { useState } from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

interface BasicTabProps {
  labels: string[];
  tabContent: React.ReactNode;
  onChangeTab: (newIndex: number) => void;
  inProgress?: boolean;
}

const BasicTabComponent = ({
  labels,
  inProgress,
  tabContent,
  onChangeTab,
}: BasicTabProps) => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    onChangeTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: '0px' }}>
        <Tabs value={value} onChange={handleChange} aria-label="crew tabs">
          {labels.map((label: any, index: number) => {
            return (
              <Tab
                key={label + '_' + index}
                disabled={inProgress}
                label={label}
                {...a11yProps(index)}
              />
            );
          })}
        </Tabs>
      </Box>
      {labels.map((label: any, index: number) => {
        return (
          <CustomTabPanel key={`${label}_${index}`} value={value} index={index}>
            {tabContent}
          </CustomTabPanel>
        );
      })}
    </Box>
  );
};

export default BasicTabComponent;
